var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable max-len */
import { useEffect, useRef, useState } from 'react';
import { useChatSocket } from './use-chat-socket';
import { queryClient } from '../../../../../queryClient';
import { queryKeys } from '../network/query-keys';
import { appendToMessage, createAssistantMessage, createUserMessage } from '../chat-message-utils';
export var useChat = function () {
    var socket = useChatSocket().socket;
    var _a = useState(null), chatId = _a[0], setChatId = _a[1];
    var _b = useState(null), chatTitle = _b[0], setChatTitle = _b[1];
    var _c = useState([]), messages = _c[0], setMessages = _c[1];
    var _d = useState(false), isRespondingState = _d[0], setIsRespondingState = _d[1];
    var isResponding = useRef(false);
    var lastMessage = useRef(null);
    var setIsResponding = function (value) {
        isResponding.current = value;
        setIsRespondingState(value);
    };
    var processBotResponse = function (botResponse) {
        var currentLastMessage = lastMessage.current;
        if (isResponding.current) {
            if (botResponse.message && botResponse.messageId === (currentLastMessage === null || currentLastMessage === void 0 ? void 0 : currentLastMessage.id)) {
                var newMessage_1 = appendToMessage(currentLastMessage, botResponse);
                setMessages(function (prevMessages) { return __spreadArray(__spreadArray([], prevMessages.slice(0, -1), true), [newMessage_1], false); });
                lastMessage.current = newMessage_1;
            }
            else {
                var nextMessage_1 = createAssistantMessage(botResponse);
                setMessages(function (prevMessages) { return __spreadArray(__spreadArray([], prevMessages, true), [nextMessage_1], false); });
                lastMessage.current = nextMessage_1;
            }
        }
        if (botResponse.endOfResponse) {
            setIsResponding(false);
        }
    };
    var processNewChatStarter = function (message) {
        setChatId(message.chat.id);
        setChatTitle(message.chat.title);
        queryClient.invalidateQueries({
            queryKey: queryKeys.chatHistory,
        });
    };
    useEffect(function () {
        if (socket) {
            socket.on('reportingBotResponse', processBotResponse);
            socket.on('exception', function (error) {
                console.error('Exception from server', error);
            });
            socket.on('reportingBotError', function (error) {
                console.error('Error from server', error);
            });
            socket.on('reportingBotNewChatStarter', processNewChatStarter);
            return function () {
                socket.off('reportingBotResponse');
                socket.off('exception');
                socket.off('reportingBotError');
                socket.off('reportingBotNewChatStarter');
            };
        }
        return function () { return null; };
    }, [socket]);
    var startNewChat = function () {
        setChatId(null);
        setMessages([]);
        setChatTitle(null);
        setIsResponding(false);
    };
    var loadChatLog = function (chatLog) {
        setChatId(chatLog.id);
        setMessages(chatLog.history);
        setChatTitle(chatLog.title);
        setIsResponding(false);
    };
    var sendMessage = function (message) {
        if (socket) {
            socket.emit('reportingBot', JSON.stringify({ message: message, chatId: chatId }));
            var newUserMessage_1 = createUserMessage(message);
            setMessages(function (prevMessages) { return __spreadArray(__spreadArray([], prevMessages, true), [newUserMessage_1], false); });
            lastMessage.current = newUserMessage_1;
            setIsResponding(true);
        }
    };
    return {
        isConnected: socket === null || socket === void 0 ? void 0 : socket.connected,
        sendMessage: sendMessage,
        messages: messages,
        chatTitle: chatTitle,
        isResponding: isRespondingState,
        isChatInProgress: !!messages.length,
        startNewChat: startNewChat,
        loadChatLog: loadChatLog,
    };
};
